import React, { useEffect, useState, useContext } from "react";
import * as moment from "moment";
import { toast } from "react-toastify";

import "./AddEmployee.css";
import getAlldesignationdrop from "apis/panel/employmentInformation/employmentinfo";
import getAlldepartmentdrop from "apis/panel/employmentInformation/employmentinfo";
import getAllemployementtypedrop from "apis/panel/employmentInformation/employmentinfo";
import getAllworklocationdrop from "apis/panel/employmentInformation/employmentinfo";
import getAllexperiencesdrop from "apis/panel/employmentInformation/employmentinfo";
import getAllemploymentcreatedrop from "apis/panel/employmentInformation/employmentinfo";
import getAllrolesdrop from "apis/panel/employmentInformation/employmentinfo";
import ReusableFunction from "utils/reusablefunction";
import Context from "context/context";
import FileHandler from "apis/panel/fileHandler/fileHandler";
import EmployeeAPI from "apis/panel/employee/employee";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import personalInfo from "assets/images/Frame (1).png";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DeleteIcon from "@mui/icons-material/Delete";
import { InputAdornment, IconButton } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ClearIcon from "@mui/icons-material/Clear";

const probationPeriods = {
  0: "Not Applicable",
  1: "1 Month",
  2: "2 Months",
  3: "3 Months",
  6: "6 Months",
  9: "9 Months",
  12: "12 Months"
};

const EmployementInfo = () => {
  const { dispatch } = useContext(Context);
  const { fileUploadAPI } = FileHandler();
  const { handleFileInputReselect } = ReusableFunction();

  const [file, setFile] = useState(null);
  const { getAlldesignationAPI } = getAlldesignationdrop();
  const [designationname, setdesignationname] = useState();
  const [designationid, setdesignationid] = useState();
  const [designationoption, setdesignationoption] = useState([]);

  const { getAlldepartmentAPI } = getAlldepartmentdrop();
  const [departmentname, setdepartmentname] = useState();
  const [departmentid, setdepartmentid] = useState();
  const [departmentoption, setdepartmentoption] = useState([]);

  const { getAllemployementtypeAPI } = getAllemployementtypedrop();
  const [employementtypename, setemployementtypename] = useState();
  const [employementtypeid, setemployementtypeid] = useState();
  const [employementtypeoption, setemployementtypeoption] = useState([]);

  const { getAllworklocationAPI } = getAllworklocationdrop();
  const [worklocationname, setworklocationname] = useState("");
  const [worklocationid, setworklocationid] = useState("");
  const [worklocationoption, setworklocationoption] = useState([]);

  const { getAllexperiencesAPI } = getAllexperiencesdrop();
  const [experiencesname, setexperiencesname] = useState();
  const [experiencesid, setexperiencesid] = useState();
  const [experiencesoption, setexperiencesoption] = useState([]);

  const { getAllRolesAPI } = getAllrolesdrop();
  const [rolesname, setrolesname] = useState();
  const [rolesid, setrolesid] = useState();
  const [rolesoption, setrolesoption] = useState([]);

  const [status, setstatus] = useState("Active");
  // const [uan, setuan] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [probationPeriod, setProbationPeriod] = useState();
  const [probationEndDate, setProbationEndDate] = useState(null);

  const [experienceInMonths, setExperienceInMonths] = useState(0);
  const [overallExperienceInMonths, setOverallExperienceInMonths] = useState(0);
  const [priorExperience, setPriorExperience] = useState("");
  const [employee, setEmployee] = useState({});

  const { getEmployeeCodeAPI } = EmployeeAPI();

  const { getEmployementcreateAPI } = getAllemploymentcreatedrop();
  const EmployeeId = sessionStorage.getItem("EmployeeID");
  const EmployeeCode = sessionStorage.getItem("EmployeeCode");

  const [errorFields, setErrorFields] = useState({
    Rolename: false,
    Departmentname: false,
    designation: false,
    employementstatus: false,
    employeetype: false,
    dateofjoining: false,
    worklocation: false,
    experience: false,
    // uan: false,
    employeeid: false,
    priorExperience: false,
  });

  const [prevExp, setPrevExp] = useState([]);

  const getFilenameFromUrl = (url) => {
    if (url !== "" && url !== undefined && url !== null) {
      const parts = url.split("/");
      return parts[parts.length - 1];
    } else {
      return "";
    }
  };

  const handleFileUpload = async (file) => {
    const allowedTypes = ["application/pdf"];

    if (!allowedTypes.includes(file?.type)) {
      toast.error("Only PDF files are allowed.", {
        toastId: "file-type-error",
      });
      return false;
    }

    const maxSize = 1024 * 1024 * 5;
    if (file.size > maxSize) {
      toast.error("File size exceeds the limit (5MB)", {
        toastId: "file-upload-maximum",
      });
      return false;
    }

    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let input = new FormData();
      input.append("type", "employee_documents");
      input.append("employeeId", EmployeeId);
      input.append("file", file);
      const res = await fileUploadAPI(input);
      dispatch({ type: "SET_LOADING", payload: false });
      if (res?.data?.location) {
        return res?.data?.location;
      }
      return false;
    } catch (err) {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handleFileChange = async (event, index) => {
    if (!EmployeeId) {
      toast.error(
        "Please create an employee account before uploading documents.",
        {
          toastId: "employeeid-error",
        }
      );
      return false;
    }

    const file = event.target.files[0];

    let newName = `${employee?.employeeCode}_${
      employee?.fullName
    }_Experience_Letter_${index + 1}`;

    newName = `${newName}.${file?.name?.split(".").pop()}`;
    const renamedFile = new File([file], newName, { type: file.type });

    const location = await handleFileUpload(renamedFile);
    if (location) {
      setPrevExp([
        ...prevExp.slice(0, index),
        {
          ...prevExp[index],
          expLetterFilePath: location,
        },
        ...prevExp.slice(index + 1),
      ]);
    }
  };

  const handleGetdesignation = async () => {
    try {
      let res = await getAlldesignationAPI();
      setdesignationoption(res?.data || []);
    } catch (err) {}
  };

  const handleGetdepartment = async () => {
    try {
      let res = await getAlldepartmentAPI();
      setdepartmentoption(res?.data || []);
    } catch (err) {}
  };

  const handleGetemployementtype = async () => {
    try {
      let res = await getAllemployementtypeAPI();
      setemployementtypeoption(res?.data || []);
    } catch (err) {}
  };

  const handleGetworklocation = async () => {
    try {
      let res = await getAllworklocationAPI();
      setworklocationoption(res?.data || []);
    } catch (err) {}
  };

  const handleGetexperiences = async () => {
    try {
      let res = await getAllexperiencesAPI();
      setexperiencesoption(res?.data || []);
    } catch (err) {}
  };

  const handleGetallRoles = async () => {
    try {
      let res = await getAllRolesAPI();
      setrolesoption(res?.data || []);
    } catch (err) {}
  };

  const handlestatusChange = (e) => {
    setstatus(e.target.value);
  };

  const handleDobAccept = (date) => {
    setDateOfBirth(date);
    // const startDate = moment(date);
    // const endDate = moment(new Date());
    // if (startDate.isValid() && endDate.isValid()) {
    //   const monthDiff = endDate.diff(startDate, "months");
    //   setExperienceInMonths(monthDiff);
    // }
  };

  // const handleuan = (e) => {
  //   setuan(e.target.value);
  // };

  useEffect(() => {
    handleGetdesignation();
    handleGetdepartment();
    handleGetemployementtype();
    handleGetworklocation();
    handleGetexperiences();
    handleGetallRoles();
  }, []);

  const handledesignationChange = (e) => {
    const selecteddesignation = designationoption.find(
      (option) => option.designationName === e.target.value
    );
    setdesignationname(selecteddesignation.designationName); // Set the titleName
    setdesignationid(selecteddesignation.designationId); // Set the titleId
  };

  const handlerolesChange = (e) => {
    const selectedrole = rolesoption.find(
      (option) => option.roleName === e.target.value
    );
    setrolesname(selectedrole.roleName);
    setrolesid(selectedrole.roleId);
  };

  const handledepartmentChange = (e) => {
    const selecteddepartment = departmentoption.find(
      (option) => option.departmentName === e.target.value
    );
    setdepartmentname(selecteddepartment.departmentName); // Set the titleName
    setdepartmentid(selecteddepartment.departmentId); // Set the titleId
  };

  const handleemployementtypeChange = (e) => {
    const selectemployementtypement = employementtypeoption.find(
      (option) => option.employmentTypeName === e.target.value
    );
    setemployementtypename(selectemployementtypement.employmentTypeName); // Set the titleName
    setemployementtypeid(selectemployementtypement.employmentTypeId); // Set the titleId
  };

  const handleworklocationChange = (e) => {
    const selectworklocationment = worklocationoption.find(
      (option) => option.workLocationName === e.target.value
    );
    setworklocationname(selectworklocationment.workLocationName); // Set the titleName
    setworklocationid(selectworklocationment.workLocationId); // Set the titleId
  };

  const handleexperiencesChange = (e) => {
    const selectexperiences = experiencesoption.find(
      (option) => option.yearsOfExperience === e.target.value
    );
    setexperiencesname(selectexperiences.yearsOfExperience); // Set the titleName
    setexperiencesid(selectexperiences.experienceId); // Set the titleId
  };

  const handleCreateemplyement = async (e) => {
    let prevExpError = false;
    let updatedArr = [];

    e.preventDefault();
    // Validate form fields
    const errors = {};
    if (!rolesid) errors.Rolename = true;
    if (!designationid) errors.designation = true;
    if (!departmentid) errors.Departmentname = true;
    if (!status) errors.employementstatus = true;
    if (!employementtypeid) errors.employeetype = true;
    if (!dateOfBirth) errors.dateofjoining = true;
    if (!worklocationid) errors.worklocation = true;
    // if (!experiencesid) errors.experience = true;
    // if (!uan) errors.uan = true;
    if (!EmployeeId) errors.employeeid = true;
    if(probationPeriod == undefined || probationPeriod == null) errors.probationPeriod = true;

    setErrorFields(errors);

    if (prevExp?.length > 0) {
      for (let index = 0; index < prevExp?.length; index++) {
        const current = { ...prevExp[index] };

        if (!current?.companyName) {
          current.companyNameError = true;
          prevExpError = true;
        } else {
          delete current.companyNameError;
        }

        if (!current?.designation) {
          current.designationError = true;
          prevExpError = true;
        } else {
          delete current.designationError;
        }

        if (!current?.startDate) {
          current.startDateError = true;
          prevExpError = true;
        } else {
          delete current.startDateError;
        }
        if (!current?.endDate) {
          current.endDateError = true;
          prevExpError = true;
        } else {
          current.endDateError = false;
        }
        if (!current?.expLetterFilePath) {
          current.expLetterFilePathError = true;
          prevExpError = true;
        } else {
          current.expLetterFilePathError = false;
        }
        const updatedPrevExp = [
          ...prevExp.slice(0, index),
          current,
          ...prevExp.slice(index + 1),
        ];

        setPrevExp(updatedPrevExp);
        updatedArr = updatedPrevExp;
      }
    }

    if (Object.keys(errors).length > 0 || prevExpError) {
      return toast.error(
        "Please complete all required fields before proceeding.",
        {
          toastId: "empty-field-error",
        }
      );
    }
    let formattedPrevExp = [];

    const safeMomentFormat = (val) => {
      if (!val) return null;

      let dateObj = null;

      if (val instanceof Date && !isNaN(val)) {
        dateObj = val;
      } else if (val?.toDate) {
        // dayjs / moment
        dateObj = val.toDate();
      } else if (typeof val === "string" || typeof val === "number") {
        const parsed = new Date(val);
        if (!isNaN(parsed)) dateObj = parsed;
      }

      return dateObj ? moment(dateObj).format("YYYY-MM-DD") : null;
    };

    updatedArr?.map((u) => {
      formattedPrevExp = [
        ...formattedPrevExp,
        {
          ...u,
          startDate: safeMomentFormat(u.startDate),
          endDate: safeMomentFormat(u.endDate),
        },
      ];
    });

    // If no errors, proceed with form submission
    if (Object.keys(errors).length === 0) {
      const values = {
        employeeId: EmployeeId,
        roleId: rolesid,
        designationId: designationid,
        departmentId: departmentid,
        status: status,
        employmentTypeId: employementtypeid,
        dateOfJoining: moment(dateOfBirth).format("YYYY-MM-DD"),
        workLocationId: worklocationid,
        currentExperience: experienceInMonths,
        totalExperience: overallExperienceInMonths,
        priorExperience: priorExperience,
        // experienceId: experiencesid,
        // uan: uan,
        prevExp: formattedPrevExp,
        probationPeriodMonths: probationPeriod,
        probationEndDate: probationEndDate? moment(probationEndDate).format("YYYY-MM-DD") : ""
      };

      const data = await getEmployementcreateAPI(values);
      if (data.status === "Ok") {
        return toast.success("Data Saved Successfully", {
          toast: "Data Saved Successfully",
        });
      } else {
        return toast.error("Error saving Data", { toast: "Error saving Data" });
      }
    }
  };

  const handleReset = () => {
    setdesignationid("");
    setdepartmentid("");
    setstatus("");
    setemployementtypeid("");
    setDateOfBirth("");
    setworklocationname("");
    setworklocationid("");
    setexperiencesid("");
    setPrevExp([]);
    setPriorExperience("")
  };

  const [accordionOpen, setAccordionOpen] = useState(false);

  const handleCancel = () => {
    setAccordionOpen(false);
  };

  const handleAddPreviousExperience = () => {
    let prevExpError = false;

    if (prevExp?.length > 0) {
      let arr = [];
      for (let index = 0; index < prevExp?.length; index++) {
        const current = { ...prevExp[index] };

        if (!current?.companyName) {
          current.companyNameError = true;
          prevExpError = true;
        } else {
          current.companyNameError = false;
        }

        if (!current?.designation) {
          current.designationError = true;
          prevExpError = true;
        } else {
          current.designationError = false;
        }

        if (!current?.startDate) {
          current.startDateError = true;
          prevExpError = true;
        } else {
          current.startDateError = false;
        }
        if (!current?.endDate) {
          current.endDateError = true;
          prevExpError = true;
        } else {
          current.endDateError = false;
        }
        if (!current?.expLetterFilePath) {
          current.expLetterFilePathError = true;
          prevExpError = true;
        } else {
          current.expLetterFilePathError = false;
        }
        arr = [...arr, current];
      }
      setPrevExp(arr);
    }

    if (prevExpError) {
      return toast.error(
        "Please complete all required fields before proceeding.",
        {
          toastId: "add-more-exp-error",
        }
      );
    }

    setPrevExp([
      ...prevExp,
      {
        employeeId: EmployeeId,
        companyName: "",
        designation: "",
        startDate: null,
        endDate: null,
        expLetterFilePath: "",
        expInMonths: 0,
      },
    ]);
  };

  const handleDelPrevExp = (index) => {
    if (index === 0) {
      setPriorExperience("");
    }
    setPrevExp([...prevExp.slice(0, index), ...prevExp.slice(index + 1)]);
  };

  // const handleInputChange = (index, key, value) => {
  //   setEditableData([
  //     ...editableData.slice(0, index),
  //     {
  //       ...editableData[index],
  //       [key]: value,
  //     },
  //     ...editableData.slice(index + 1),
  //   ]);
  // };

  useEffect(() => {
    if (dateOfBirth) {
      const startDate = moment(dateOfBirth);
      const endDate = moment(new Date());
      if (
        startDate.isValid() &&
        endDate.isValid() &&
        startDate.isBefore(moment())
      ) {
        const monthDiff = endDate.diff(startDate, "months");
        setExperienceInMonths(monthDiff);
        let overallPrevExp = 0;
        prevExp?.map((px) => {
          overallPrevExp += px.expInMonths;
        });
        setOverallExperienceInMonths(overallPrevExp + monthDiff);
      } else {
        setExperienceInMonths(0);
        setOverallExperienceInMonths(0);
      }
    }
  }, [dateOfBirth, prevExp]);

  const handleGetEmployeeCode = async (e) => {
    const values = {
      employeeId: EmployeeId,
    };
    const res = await getEmployeeCodeAPI(values);
    const data = res?.data?.employee;
    setEmployee(data);
  };

  useEffect(() => {
    if (EmployeeId) {
      handleGetEmployeeCode();
    }
  }, [EmployeeId]);

  useEffect(()=>{
    if(dateOfBirth && probationPeriod !== undefined && probationPeriod !== null){
    const date =  moment(dateOfBirth).add(parseInt(probationPeriod), 'months').toDate() 
    if(probationPeriod === 0){
    setProbationEndDate(null)
    }else{
    setProbationEndDate(date)
    }
    }
  },[dateOfBirth,probationPeriod])

  return (
    <Accordion
      expanded={accordionOpen}
      onChange={() => setAccordionOpen(!accordionOpen)}
      sx={{ mt: 2, boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}
    >
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon className="Accordianicon" />}
        aria-controls="panel1-content"
        id="panel1-header"
        style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px", height: "70px" }}
      >
        <Box sx={{ pl: 3 }}>
          {" "}
          <img
            sx={{ pl: 3 }}
            className="personalInfo-logo"
            src={personalInfo}
            alt="info"
          />
        </Box>
        <Box className="acc-title" sx={{ pl: 3 }}>
          Employment Information
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2} sx={{ pl: 4, pr: 5, mt: 2 }}>
          {/* <Box>Current Addres</Box> */}

          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">
              Employee Id <span style={{ color: "red" }}>*</span>
            </Box>
            <TextField
              id="firstName"
              placeholder="Employee Id"
              variant="outlined"
              fullWidth
              value={EmployeeCode}
              sx={{ border: "1.5px solid #B2D4F8" }}
              disabled
            />
            {errorFields.employeeid && (
              <span className="error-msg">Employee Id is required</span>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ pl: 4, pr: 5, mt: 2 }}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">
              {" "}
              Role <span style={{ color: "red" }}>*</span>
            </Box>
            <FormControl fullWidth>
              <Select
                labelId="title-label"
                id="title"
                style={{ border: "1px solid #B2D4F8", color: "grey" }}
                defaultValue=""
                name="title"
                value={rolesname}
                onChange={handlerolesChange}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem value="">Select Role</MenuItem>

                {rolesoption.map((option) => (
                  <MenuItem key={option.id} value={option.roleName}>
                    {option.roleName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {errorFields.Rolename && (
              <span className="error-msg">Role is required</span>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">
              {" "}
              Designation <span style={{ color: "red" }}>*</span>
            </Box>
            <FormControl fullWidth>
              <Select
                labelId="title-label"
                id="title"
                style={{ border: "1px solid #B2D4F8", color: "grey" }}
                defaultValue=""
                name="title"
                value={designationname}
                onChange={handledesignationChange}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem value="">Select Designation</MenuItem>

                {designationoption.map((option) => (
                  <MenuItem key={option.id} value={option.designationName}>
                    {option.designationName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {errorFields.designation && (
              <span className="error-msg">Designation is required</span>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ pl: 4, pr: 5, mt: 2 }}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">
              {" "}
              Department <span style={{ color: "red" }}>*</span>
            </Box>
            <FormControl fullWidth>
              <Select
                labelId="title-label"
                id="title"
                style={{ border: "1px solid #B2D4F8", color: "grey" }}
                defaultValue=""
                name="title"
                value={departmentname}
                onChange={handledepartmentChange}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem value="">Select Department</MenuItem>

                {departmentoption.map((option) => (
                  <MenuItem key={option.id} value={option.departmentName}>
                    {option.departmentName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {errorFields.Departmentname && (
              <span className="error-msg">Department is required</span>
            )}
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">
              {" "}
              Employment Status <span style={{ color: "red" }}>*</span>
            </Box>
            <FormControl fullWidth>
              {/* <InputLabel id="marital-status-label">Country</InputLabel> */}
              <Select
                labelId="marital-status-label"
                id="maritalStatus"
                placeholder="Select Employement Status"
                defaultValue=""
                displayEmpty
                value={status}
                onChange={handlestatusChange}
                inputProps={{ "aria-label": "Without label" }}
                style={{ border: "1.5px solid #B2D4F8", color: "grey" }}
                //   label="Marital Status"
              >
                <MenuItem value="">Select Status</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
            {errorFields.employementstatus && (
              <span className="error-msg">Employment status is required</span>
            )}
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ pl: 4, pr: 5, mt: 2 }}>
          {/* <Box>Current Addres</Box> */}

          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">
              Employment Type<span style={{ color: "red" }}>*</span>
            </Box>
            <FormControl fullWidth>
              {/* <InputLabel id="marital-status-label">Country</InputLabel> */}
              <Select
                labelId="marital-status-label"
                id="maritalStatus"
                placeholder="Select Employement Type"
                defaultValue=""
                displayEmpty
                value={employementtypename}
                onChange={handleemployementtypeChange}
                inputProps={{ "aria-label": "Without label" }}
                style={{ border: "1.5px solid #B2D4F8", color: "grey" }}
                //   label="Marital Status"
              >
                <MenuItem value="">Select Employment Type</MenuItem>
                {employementtypeoption.map((option) => (
                  <MenuItem key={option.id} value={option.employmentTypeName}>
                    {option.employmentTypeName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {errorFields.employeetype && (
              <span className="error-msg">Employment Type is required</span>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">
              Date of Joining<span style={{ color: "red" }}>*</span>
            </Box>
            <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
              <DatePicker
                sx={{ width: "100%" }}
                fullWidth
                onAccept={handleDobAccept}
                slotProps={{
                  field: { clearable: true },
                }}
                maxDate={moment().add(1, "months").toDate()}
                format="dd/MM/yyyy"
              />
            </LocalizationProvider>
            {errorFields.dateofjoining && (
              <span className="error-msg">Date Of Joining is required</span>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ pl: 4, pr: 5, mt: 2 }}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">
              Work Location<span style={{ color: "red" }}>*</span>
            </Box>
            <FormControl fullWidth>
              {/* <InputLabel id="marital-status-label">Country</InputLabel> */}
              <Select
                labelId="marital-status-label"
                id="maritalStatus"
                placeholder="Select Work Location"
                defaultValue=""
                value={worklocationname}
                onChange={handleworklocationChange}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                style={{ border: "1.5px solid #B2D4F8", color: "grey" }}
                //   label="Marital Status"
              >
                <MenuItem value="">Select Location</MenuItem>

                {worklocationoption.map((option) => (
                  <MenuItem key={option.id} value={option.workLocationName}>
                    {option.workLocationName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {errorFields.worklocation && (
              <span className="error-msg">Work location is required</span>
            )}
          </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  Probation Period<span style={{ color: "red" }}>*</span>
                </Box>
                <FormControl fullWidth>
                  <Select
                    labelId="probation-period-label"
                    id="probation-period"
                    placeholder="Select Probation Period"
                    defaultValue=""
                    displayEmpty
                    value={probationPeriod}
                    onChange={(e)=>{
                      setProbationPeriod(parseInt(e.target.value))
                    }}
                    inputProps={{ "aria-label": "Without label" }}
                    style={{ border: "1.5px solid #B2D4F8", color: "grey" }}
                  >
                    {Object.keys(probationPeriods)?.map((key) => (
                      <MenuItem
                        key={probationPeriods[key]}
                        value={key}
                      >
                        {probationPeriods[key]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errorFields.probationPeriod && (
                  <span className="error-msg">
                    Probation Period is required
                  </span>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                 Probation End Date
                </Box>
               <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
                  <DatePicker
                    sx={{ width: "100%" }}
                    id="dateOfBirth"
                    name="dateOfBirth"
                    value={probationEndDate ?? null}
                    format="dd/MM/yyyy"
                    renderInput={(params) => (
                      <TextField {...params} helperText={null} />
                    )}
                    disabled={true}
                  />
                </LocalizationProvider>
              </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">
              Current Experience in ValueHealth (Months)
            </Box>
            <TextField
              id="experience-in-valuehealth"
              variant="outlined"
              fullWidth
              type="number"
              InputProps={{ inputProps: { min: 0, max: 100 } }}
              disabled={true}
              value={experienceInMonths || 0}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ pl: 4, pr: 5, mt: 2 }}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label" style={{ color: "black" }}>
              Total Year of Employment Experience (Months)
            </Box>
            <TextField
              id="overall-experience-in-valuehealth"
              variant="outlined"
              fullWidth
              type="number"
              InputProps={{ inputProps: { min: 0, max: 100 } }}
              disabled={true}
              value={overallExperienceInMonths || 0}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">
              Do you have any previous experience?
            </Box>
            <FormControl fullWidth>
              <Select
                labelId="prior-experience"
                id="prior-experience"
                defaultValue=""
                value={priorExperience}
                onChange={(e) => {
                  setPriorExperience(e.target.value);
                  if (e.target.value === "Yes") {
                    handleAddPreviousExperience();
                  } else {
                    setPrevExp([]);
                  }
                }}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                style={{ border: "1.5px solid #B2D4F8", color: "grey" }}
              >
                {["Yes", "No"].map((option) => (
                  <MenuItem key={option.id} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* <Grid container spacing={2} sx={{ pl: 4, pr: 5, mt: 2 }}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box className="label">
              UAN<span style={{ color: "red" }}>*</span>
            </Box>
            <TextField
              id="firstName"
              placeholder="Enter UAN"
              variant="outlined"
              fullWidth
              onChange={handleuan}
            />
            {errorFields.uan && (
              <span className="error-msg">UAN is required</span>
            )}
          </Grid>
        </Grid> */}

        {prevExp?.length > 0 && (
          <Grid container spacing={0} className="prev-exp-parent">
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Button
                className="prev-exp-btn"
                onClick={handleAddPreviousExperience}
              >
                Add More Experience
              </Button>
            </Grid>
          </Grid>
        )}

        {prevExp?.map((section, index) => (
          <div key={index}>
            <Grid container spacing={2} sx={{ pl: 3, pr: 5, mt: 2 }}>
              <Box
                className="subHeadingforinfos"
                sx={{ pl: 3 }}
                style={{ alignSelf: "center" }}
              >
                Previous Experience - {index + 1}
              </Box>
              <button
                className="prev-exp-rem-btn"
                onClick={() => {
                  handleDelPrevExp(index);
                }}
              >
                Remove
              </button>
            </Grid>
            <Grid container spacing={2} sx={{ pl: 4, pr: 5, mt: 2 }}>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  Company Name<span style={{ color: "red" }}>*</span>
                </Box>
                <TextField
                  id="firstName"
                  placeholder="Enter Company Name"
                  variant="outlined"
                  fullWidth
                  value={prevExp[index]?.companyName || ""}
                  onChange={(e) => {
                    setPrevExp([
                      ...prevExp.slice(0, index),
                      {
                        ...prevExp[index],
                        companyName: e.target.value,
                      },
                      ...prevExp.slice(index + 1),
                    ]);
                  }}
                />
                {prevExp[index]?.companyNameError && (
                  <span className="error-msg">Company Name is required</span>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  Designation<span style={{ color: "red" }}>*</span>
                </Box>
                <TextField
                  id="firstName"
                  placeholder="Enter Designation"
                  variant="outlined"
                  fullWidth
                  value={prevExp[index]?.designation || ""}
                  onChange={(e) => {
                    setPrevExp([
                      ...prevExp.slice(0, index),
                      {
                        ...prevExp[index],
                        designation: e.target.value,
                      },
                      ...prevExp.slice(index + 1),
                    ]);
                  }}
                />
                {prevExp[index]?.designationError && (
                  <span className="error-msg">Designation is required</span>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  Start Date<span style={{ color: "red" }}>*</span>
                </Box>
                <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
                  <DatePicker
                    sx={{ width: "100%" }}
                    fullWidth
                    value={prevExp[index]?.startDate || null}
                    onChange={(date) => {
                      let monthDiff;

                      let updateObj = {
                        startDate: date,
                      };

                      if (date === null) {
                        updateObj = { startDate: null, expInMonths: null };
                      } else {
                        const startDate = moment(date);
                        const endDate = moment(prevExp[index]?.endDate);
                        if (startDate.isValid() && endDate.isValid()) {
                          monthDiff = endDate.diff(startDate, "months");
                          updateObj = { ...updateObj, expInMonths: monthDiff };
                        }
                      }

                      setPrevExp([
                        ...prevExp.slice(0, index),
                        { ...prevExp[index], ...updateObj },
                        ...prevExp.slice(index + 1),
                      ]);
                    }}
                    slotProps={{
                      field: { clearable: true },
                    }}
                    maxDate={
                      moment(dateOfBirth).subtract(1, "days").toDate() ||
                      new Date()
                    }
                    disabled={!dateOfBirth}
                  />
                </LocalizationProvider>

                {prevExp[index]?.startDateError && (
                  <span className="error-msg">Start Date is required</span>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  End Date<span style={{ color: "red" }}>*</span>
                </Box>
                <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
                  <DatePicker
                    sx={{ width: "100%" }}
                    fullWidth
                    value={prevExp[index]?.endDate || null}
                    onChange={(date) => {
                      let monthDiff;
                      let updateObj = { endDate: date };

                      if (date === null) {
                        updateObj = { endDate: null, expInMonths: null };
                      } else {
                        const startDate = moment(prevExp[index]?.startDate);
                        const endDate = moment(date);

                        if (startDate.isValid() && endDate.isValid()) {
                          monthDiff = endDate.diff(startDate, "months");
                          updateObj = { ...updateObj, expInMonths: monthDiff };
                        }
                      }

                      setPrevExp([
                        ...prevExp.slice(0, index),
                        { ...prevExp[index], ...updateObj },
                        ...prevExp.slice(index + 1),
                      ]);
                    }}
                    slotProps={{
                      field: { clearable: true },
                    }}
                    minDate={prevExp[index]?.startDate || null}
                    maxDate={
                      moment(dateOfBirth).subtract(1, "days").toDate() ||
                      new Date()
                    }
                    disabled={!prevExp[index]?.startDate}
                  />
                </LocalizationProvider>
                {prevExp[index]?.endDateError && (
                  <span className="error-msg">End Date is required</span>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  Experience Letter (PDF){" "}
                  <span style={{ color: "red" }}>*</span>
                </Box>
                <TextField
                  className="editvalue"
                  fullWidth
                  placeholder="Browse Files (max of 5mb) "
                  value={getFilenameFromUrl(prevExp[index]?.expLetterFilePath)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {prevExp[index]?.expLetterFilePath && (
                          <IconButton
                            onClick={() => {
                              setPrevExp([
                                ...prevExp.slice(0, index),
                                {
                                  ...prevExp[index],
                                  expLetterFilePath: null,
                                },
                                ...prevExp.slice(index + 1),
                              ]);
                            }}
                            edge="end"
                            aria-label="clear file"
                          >
                            <ClearIcon />
                          </IconButton>
                        )}
                        <input
                          type="file"
                          accept=".pdf"
                          id={`experience-letter-${index}`}
                          style={{ display: "none" }}
                          onClick={handleFileInputReselect}
                          onChange={(e) => {
                            handleFileChange(e, index);
                          }}
                        />
                        <label htmlFor={`experience-letter-${index}`}>
                          <IconButton
                            component="span"
                            color="primary"
                            aria-label="attach file"
                          >
                            <AttachFileIcon style={{ color: "#0056B2" }} />
                          </IconButton>
                        </label>
                      </InputAdornment>
                    ),
                  }}
                />
                {prevExp[index]?.expLetterFilePathError && (
                  <span className="error-msg">
                    Experience Letter is required
                  </span>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">Experience (Months)</Box>
                <TextField
                  id="experience"
                  variant="outlined"
                  fullWidth
                  type="number"
                  InputProps={{ inputProps: { min: 0, max: 100 } }}
                  disabled={true}
                  value={prevExp[index]?.expInMonths || 0}
                />
              </Grid>
            </Grid>
          </div>
        ))}

        <Grid
          container
          spacing={1}
          sx={{ pl: 4, pr: 5, mt: 5, justifyContent: "center" }}
        >
          <Grid item xs={12} sm={3} md={3} lg={3}>
            <Button className="resetChanges" onClick={handleReset}>
              Reset Changes
            </Button>
          </Grid>

          <Grid item xs={12} sm={2} md={2} lg={2}>
            <Button className="cancelButton" onClick={handleCancel}>
              Cancel
            </Button>
          </Grid>

          <Grid item xs={12} sm={2} md={2} lg={2}>
            <Button className="saveButton" onClick={handleCreateemplyement}>
              Save
            </Button>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default EmployementInfo;
